import { render, staticRenderFns } from "./adminGroup.vue?vue&type=template&id=43f9b004&scoped=true"
import script from "./adminGroup.vue?vue&type=script&lang=js"
export * from "./adminGroup.vue?vue&type=script&lang=js"
import style0 from "./adminGroup.vue?vue&type=style&index=0&id=43f9b004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f9b004",
  null
  
)

export default component.exports